<template>
	<transition
			appear
			:appear-active-class="$_rctInpLyt_stylePageLayoutAnimation()">
		<v-row id="_rctInpLyt_top" class="customVRow" no-gutters>
			<v-col>
				<v-stepper
						v-model="stepNumber_"
						class="stepper_"
						:dark="$_rctInpLyt_styleStepperDark"
						:light="$_rctInpLyt_styleStepperLight"
						:vertical="$_rctInpLyt_stateAppIsMobileScreen">
					<!-- stepper header ( only for web ) -->
					<template v-if="!$_rctInpLyt_stateAppIsMobileScreen">
						<v-row no-gutters>
							<v-col>
								<v-sheet
										class="customVSheet px-3 ma-3"
										:color="$_rctInpLyt_styleStepperSheetColor"
										:dark="$_rctInpLyt_styleStepperSheetDark"
										:elevation="$_rctInpLyt_styleStepperSheetElevation"
										:light="$_rctInpLyt_styleStepperSheetLight">
									<v-stepper-header class="stepperHeader_">
										<v-row>
											<template v-for="(stepVals, stepKey) in step_">
												<v-col :key="stepKey">
													<v-card	class="customVCard"
															:color="$_rctInpLyt_styleStepperHeaderCardColor"
															:dark="$_rctInpLyt_styleStepperHeaderCardDark"
															:elevation="$_rctInpLyt_styleStepperHeaderCardElevation"
															:flat="$_rctInpLyt_styleStepperHeaderCardFlat"
															:hover="$_rctInpLyt_styleStepperHeaderCardHover"
															:light="$_rctInpLyt_styleStepperHeaderCardLight"
															:outlined="$_rctInpLyt_styleStepperHeaderCardOutlined"
															:raised="$_rctInpLyt_styleStepperHeaderCardRaised"
															:tile="$_rctInpLyt_styleStepperHeaderCardTile">
														<v-stepper-step 
																class="stepperStep_"
																:color="$_rctInpLyt_styleStepperStepColor"
																:complete="completed_[stepKey]"
																:step="stepVals.step">
															<span v-html="stepVals.title" />
														</v-stepper-step>
													</v-card>
												</v-col>
											</template>
										</v-row>
									</v-stepper-header>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
					<!-- stepper body ( input mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step head (only for mobile) -->
						<template v-if="$_rctInpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_rctInpLyt_styleStepperSheetColor"
											:dark="$_rctInpLyt_styleStepperSheetDark"
											:elevation="$_rctInpLyt_styleStepperSheetElevation"
											:light="$_rctInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_rctInpLyt_styleStepperHeaderCardColor"
														:dark="$_rctInpLyt_styleStepperHeaderCardDark"
														:elevation="$_rctInpLyt_styleStepperHeaderCardElevation"
														:flat="$_rctInpLyt_styleStepperHeaderCardFlat"
														:hover="$_rctInpLyt_styleStepperHeaderCardHover"
														:light="$_rctInpLyt_styleStepperHeaderCardLight"
														:outlined="$_rctInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_rctInpLyt_styleStepperHeaderCardRaised"
														:tile="$_rctInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_rctInpLyt_styleStepperStepColor"
															:complete="completed_.input"
															:step="step_.input.step">
														<span v-html="step_.input.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.input.step">
							<validation-observer v-slot="validation">
								<v-form>
									<template v-if="errorMessage_">
										<v-row>
											<v-col>
												<span v-html="errorMessage_" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_rctInpLyt_styleStepperSheetColor"
													:dark="$_rctInpLyt_styleStepperSheetDark"
													:elevation="$_rctInpLyt_styleStepperSheetElevation"
													:light="$_rctInpLyt_styleStepperSheetLight">
												<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
													<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
														<template v-if="contentVals.title">
															<v-row :key="`title-${contentKey}`">
																<v-col>
																	<v-card class="customVCard"
																			:color="$_rctInpLyt_styleStepperBodyCardColor"
																			:dark="$_rctInpLyt_styleStepperBodyCardDark"
																			:elevation="$_rctInpLyt_styleStepperBodyCardElevation"
																			:flat="$_rctInpLyt_styleStepperBodyCardFlat"
																			:hover="$_rctInpLyt_styleStepperBodyCardHover"
																			:light="$_rctInpLyt_styleStepperBodyCardLight"
																			:outlined="$_rctInpLyt_styleStepperBodyCardOutlined"
																			:raised="$_rctInpLyt_styleStepperBodyCardRaised"
																			:tile="$_rctInpLyt_styleStepperBodyCardTile">
																		<v-card-text>
																			<v-row dense>
																				<v-col>
																					<span	class="title"
																							v-html="$_rctInpLyt_langContentTitle(contentVals)" />
																				</v-col>
																			</v-row>
																		</v-card-text>
																	</v-card>
																</v-col>
															</v-row>
														</template>
														<v-row :key="`content-${contentKey}`">
															<v-col>
																<v-card class="customVCard"
																		:color="$_rctInpLyt_styleStepperBodyCardColor"
																		:dark="$_rctInpLyt_styleStepperBodyCardDark"
																		:elevation="$_rctInpLyt_styleStepperBodyCardElevation"
																		:flat="$_rctInpLyt_styleStepperBodyCardFlat"
																		:hover="$_rctInpLyt_styleStepperBodyCardHover"
																		:light="$_rctInpLyt_styleStepperBodyCardLight"
																		:outlined="$_rctInpLyt_styleStepperBodyCardOutlined"
																		:raised="$_rctInpLyt_styleStepperBodyCardRaised"
																		:tile="$_rctInpLyt_styleStepperBodyCardTile">
																	<template v-if="isObject(contentVals.bigImage)">
																		<v-row>
																			<v-col>
																				<v-img	class="customVImg"
																						:src="$_rctInpLyt_styleContentBigImageUrl(contentVals)" />
																			</v-col>
																		</v-row>
																	</template>
																	<template v-if="isObject(contentVals.video)">
																		<v-row>
																			<v-col>
																				<card-video
																						:contentKey="contentKey"
																						:contents="contents"
																						:inits="inits" />
																			</v-col>
																		</v-row>
																	</template>
																	<v-row>
																		<template v-if="!isFalse($_rctInpLyt_langContentText(contentVals))">
																			<v-col>
																				<v-card-text>
																					<v-row no-gutters>
																						<v-col>
																							<span 	class="subtitle-1 markdown"
																									v-html="marked($_rctInpLyt_langContentText(contentVals))" />
																						</v-col>
																					</v-row>
																				</v-card-text>
																			</v-col>
																		</template>
																		<template v-if="isObject(contentVals.image)">
																			<v-col cols="12" md="4" class="center">
																				<v-img	class="customVImg"
																						:src="$_rctInpLyt_styleContentImageUrl(contentVals)" />
																			</v-col>
																		</template>
																	</v-row>
																	<v-row>
																		<v-col>
																			<v-card-text>
																				<!-- check box -->
																				<template v-if="contentVals.type.checkbox">
																					<v-row no-gutters>
																						<v-col>
																							<input-checkbox
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- combobox -->
																				<template v-if="contentVals.type.combobox">
																					<v-row no-gutters>
																						<v-col>
																							<input-combobox
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- combobox multiple -->
																				<template v-if="contentVals.type.comboboxMultiple">
																					<v-row no-gutters>
																						<v-col>
																							<input-combobox-multiple
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- radio button -->
																				<template v-if="contentVals.type.radioButton">
																					<v-row no-gutters>
																						<v-col>
																							<input-radio-button
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- select -->
																				<template v-if="contentVals.type.select">
																					<v-row no-gutters>
																						<v-col>
																							<input-select
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- select multiple -->
																				<template v-if="contentVals.type.selectMultiple">
																					<v-row no-gutters>
																						<v-col>
																							<input-select-multiple
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- slider -->
																				<template v-if="contentVals.type.slider">
																					<v-row no-gutters>
																						<v-col>
																							<input-slider
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- switch -->
																				<template v-if="contentVals.type.switch">
																					<v-row no-gutters>
																						<v-col>
																							<input-switch
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- textarea -->
																				<template v-if="contentVals.type.textarea">
																					<v-row no-gutters>
																						<v-col>
																							<input-textarea
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- text field -->
																				<template v-if="contentVals.type.textField">
																					<v-row no-gutters>
																						<v-col>
																							<input-text-field
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																			</v-card-text>
																		</v-col>
																	</v-row>
																	<!-- action buttons --> 
																	<template v-if="!isEmpty(contentVals.actionButtons)">
																		<v-row>
																			<v-col>
																				<v-card-actions>
																					<v-row dense>
																						<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																							<v-col :key="actionButtonKey" cols="auto">
																								<v-btn	class="customVBtn"
																										:block="$_rctInpLyt_styleQuestionActionButtonBlock"
																										:color="$_rctInpLyt_styleQuestionActionButtonColor"
																										:dark="$_rctInpLyt_styleQuestionActionButtonDark"
																										:depressed="$_rctInpLyt_styleQuestionActionButtonDepressed"
																										:elevation="$_rctInpLyt_styleQuestionActionButtonElevation"
																										:large="$_rctInpLyt_styleQuestionActionButtonLarge"
																										:light="$_rctInpLyt_styleQuestionActionButtonLight"
																										:outlined="$_rctInpLyt_styleQuestionActionButtonOutlined"
																										:rounded="$_rctInpLyt_styleQuestionActionButtonRounded"
																										:small="$_rctInpLyt_styleQuestionActionButtonSmall"
																										:text="$_rctInpLyt_styleQuestionActionButtonFlat"
																										@click="openLink(actionButtonVals.link)"
																										v-text="$_rctInpLyt_langActionButtonTitle(actionButtonVals)" />
																							</v-col>
																						</template>
																					</v-row>
																				</v-card-actions>
																			</v-col>
																		</v-row>
																	</template>
																</v-card>
															</v-col>
														</v-row>
													</template>
												</template>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_rctInpLyt_styleStepperActionButtonBlock"
													:color="$_rctInpLyt_styleStepperActionButtonColorSubmit"
													:dark="!validation.passed && !validation.valid ? $_rctInpLyt_stateAppIsDarkTheme : $_rctInpLyt_styleStepperActionButtonDark"
													:depressed="$_rctInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_rctInpLyt_styleStepperActionButtonElevation"
													:large="$_rctInpLyt_styleStepperActionButtonLarge"
													:light="$_rctInpLyt_styleStepperActionButtonLight"
													:outlined="$_rctInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_rctInpLyt_styleStepperActionButtonRounded"
													:small="$_rctInpLyt_styleStepperActionButtonSmall"
													:text="$_rctInpLyt_styleStepperActionButtonFlat"

													:disabled="!validation.passed && !validation.valid"
													
													@click="$_rctInpLyt_submit()"
													v-text="$_rctInpLyt_langSubmitButton" />
										</v-col>
									</v-row>
								</v-form>
							</validation-observer>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( submit mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step header (only for mobile) -->
						<template v-if="$_rctInpLyt_stateAppIsMobileScreen">
							<v-row no-gutters>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_rctInpLyt_styleStepperSheetColor"
											:dark="$_rctInpLyt_styleStepperSheetDark"
											:elevation="$_rctInpLyt_styleStepperSheetElevation"
											:light="$_rctInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_rctInpLyt_styleStepperHeaderCardColor"
														:dark="$_rctInpLyt_styleStepperHeaderCardDark"
														:elevation="$_rctInpLyt_styleStepperHeaderCardElevation"
														:flat="$_rctInpLyt_styleStepperHeaderCardFlat"
														:hover="$_rctInpLyt_styleStepperHeaderCardHover"
														:light="$_rctInpLyt_styleStepperHeaderCardLight"
														:outlined="$_rctInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_rctInpLyt_styleStepperHeaderCardRaised"
														:tile="$_rctInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_rctInpLyt_styleStepperStepColor"
															:complete="completed_.submit"
															:step="step_.submit.step">
														<span v-html="step_.submit.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.submit.step">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_rctInpLyt_styleStepperSheetColor"
											:dark="$_rctInpLyt_styleStepperSheetDark"
											:elevation="$_rctInpLyt_styleStepperSheetElevation"
											:light="$_rctInpLyt_styleStepperSheetLight">
										<template v-for="(answerVals, answerKey) in sortObject($_rctInpLyt_stateInputData, 'order')">
											<template v-if="answerVals.question.title">
												<v-row :key="`title-${answerKey}`">
													<v-col>
														<v-card class="customVCard"
																:color="$_rctInpLyt_styleStepperBodyCardColor"
																:dark="$_rctInpLyt_styleStepperBodyCardDark"
																:elevation="$_rctInpLyt_styleStepperBodyCardElevation"
																:flat="$_rctInpLyt_styleStepperBodyCardFlat"
																:hover="$_rctInpLyt_styleStepperBodyCardHover"
																:light="$_rctInpLyt_styleStepperBodyCardLight"
																:outlined="$_rctInpLyt_styleStepperBodyCardOutlined"
																:raised="$_rctInpLyt_styleStepperBodyCardRaised"
																:tile="$_rctInpLyt_styleStepperBodyCardTile">
															<v-card-text>
																<v-row dense>
																	<v-col>
																		<span	class="title"
																				v-html="answerVals.question.title" />
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-col>
												</v-row>
											</template>
											<v-row :key="`content-${answerKey}`">
												<v-col>
													<v-card class="customVCard"
															:color="$_rctInpLyt_styleStepperBodyCardColor"
															:dark="$_rctInpLyt_styleStepperBodyCardDark"
															:elevation="$_rctInpLyt_styleStepperBodyCardElevation"
															:flat="$_rctInpLyt_styleStepperBodyCardFlat"
															:hover="$_rctInpLyt_styleStepperBodyCardHover"
															:light="$_rctInpLyt_styleStepperBodyCardLight"
															:outlined="$_rctInpLyt_styleStepperBodyCardOutlined"
															:raised="$_rctInpLyt_styleStepperBodyCardRaised"
															:tile="$_rctInpLyt_styleStepperBodyCardTile">
														<template v-if="!isFalse(answerVals.question.text)">
															<v-card-title>
																<v-row dense>
																	<v-col>
																		<span	class="subtitle-1 markdown"
																				v-html="marked(answerVals.question.text)" />
																	</v-col>
																</v-row>
															</v-card-title>
														</template>
														<v-card-text>
															<template v-if="answerVals.type == 'checkbox' || answerVals.type == 'switch'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<template v-if="vals.value">
																			<v-col :key="key" cols="auto">
																				<span 	class="subtitle-1"
																						v-html="vals.text" />
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'combobox'">
																<v-row dense>
																	<v-col cols="auto">
																		<template v-if="isObject(answerVals.answer)">
																			<span	class="subtitle-1"
																					v-html="answerVals.answer.text" />
																		</template>
																		<template v-else>
																			<span 	class="subtitle-1"
																					v-html="answerVals.answer" />
																		</template>
																	</v-col>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'comboboxMultiple'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<template v-if="isObject(vals)">
																			<v-col :key="key" cols="auto">
																				<span 	class="subtitle-1"
																						v-html="vals.text" />
																			</v-col>
																		</template>
																		<template v-else>
																			<v-col :key="key" cols="auto">
																				<span 	class="subtitle-1"
																						v-html="vals" />
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'radioButton' || answerVals.type == 'select'">
																<v-row dense>
																	<v-col cols="auto">
																		<span 	class="subtitle-1"
																				v-html="answerVals.answer.text" />
																	</v-col>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'selectMultiple'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<v-col :key="key" cols="auto">
																			<span 	class="subtitle-1"
																					v-html="vals.text" />
																		</v-col>
																	</template>
																</v-row>
															</template>
															<template v-else>
																<v-row dense>
																	<v-col cols="auto">
																		<span 	class="subtitle-1"
																				v-html="answerVals.answer" />
																	</v-col>
																</v-row>
															</template>
														</v-card-text>
													</v-card>
												</v-col>
											</v-row>
										</template>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row	align="center"
									justify="center">
								<!-- back button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_rctInpLyt_styleStepperActionButtonBlock"
											:color="$_rctInpLyt_styleStepperActionButtonColorBack"
											:dark="$_rctInpLyt_styleStepperActionButtonDark"
											:depressed="$_rctInpLyt_styleStepperActionButtonDepressed"
											:elevation="$_rctInpLyt_styleStepperActionButtonElevation"
											:large="$_rctInpLyt_styleStepperActionButtonLarge"
											:light="$_rctInpLyt_styleStepperActionButtonLight"
											:outlined="$_rctInpLyt_styleStepperActionButtonOutlined"
											:rounded="$_rctInpLyt_styleStepperActionButtonRounded"
											:small="$_rctInpLyt_styleStepperActionButtonSmall"
											:text="$_rctInpLyt_styleStepperActionButtonFlat"
											@click="$_rctInpLyt_back()"
											v-text="$_rctInpLyt_langBackButton" />
								</v-col>
								<!-- confirm button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_rctInpLyt_styleStepperActionButtonBlock"
											:color="$_rctInpLyt_styleStepperActionButtonColorConfirm"
											:dark="$_rctInpLyt_styleStepperActionButtonDark"
											:depressed="$_rctInpLyt_styleStepperActionButtonDepressed"
											:elevation="$_rctInpLyt_styleStepperActionButtonElevation"
											:large="$_rctInpLyt_styleStepperActionButtonLarge"
											:light="$_rctInpLyt_styleStepperActionButtonLight"
											:outlined="$_rctInpLyt_styleStepperActionButtonOutlined"
											:rounded="$_rctInpLyt_styleStepperActionButtonRounded"
											:small="$_rctInpLyt_styleStepperActionButtonSmall"
											:text="$_rctInpLyt_styleStepperActionButtonFlat"
											@click="$_rctInpLyt_confirm()">
										<template v-if="onProgress_">
											<progress-circular />
										</template>
										<template v-else>
											<span v-text="$_rctInpLyt_langConfirmButton" />
										</template>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( finish mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step header (only for mobile) -->
						<template v-if="$_rctInpLyt_stateAppIsMobileScreen">
							<v-row no-gutters>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_rctInpLyt_styleStepperSheetColor"
											:dark="$_rctInpLyt_styleStepperSheetDark"
											:elevation="$_rctInpLyt_styleStepperSheetElevation"
											:light="$_rctInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_rctInpLyt_styleStepperHeaderCardColor"
														:dark="$_rctInpLyt_styleStepperHeaderCardDark"
														:elevation="$_rctInpLyt_styleStepperHeaderCardElevation"
														:flat="$_rctInpLyt_styleStepperHeaderCardFlat"
														:hover="$_rctInpLyt_styleStepperHeaderCardHover"
														:light="$_rctInpLyt_styleStepperHeaderCardLight"
														:outlined="$_rctInpLyt_styleStepperHeaderCardOutlined"
														:raised="$_rctInpLyt_styleStepperHeaderCardRaised"
														:tile="$_rctInpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_rctInpLyt_styleStepperStepColor"
															:complete="completed_.finish"
															:step="step_.finish.step">
														<span v-html="step_.finish.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.finish.step">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_rctInpLyt_styleStepperSheetColor"
											:dark="$_rctInpLyt_styleStepperSheetDark"
											:elevation="$_rctInpLyt_styleStepperSheetElevation"
											:light="$_rctInpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_rctInpLyt_styleStepperBodyCardColor"
														:dark="$_rctInpLyt_styleStepperBodyCardDark"
														:elevation="$_rctInpLyt_styleStepperBodyCardElevation"
														:flat="$_rctInpLyt_styleStepperBodyCardFlat"
														:hover="$_rctInpLyt_styleStepperBodyCardHover"
														:light="$_rctInpLyt_styleStepperBodyCardLight"
														:outlined="$_rctInpLyt_styleStepperBodyCardOutlined"
														:raised="$_rctInpLyt_styleStepperBodyCardRaised"
														:tile="$_rctInpLyt_styleStepperBodyCardTile">
													<v-card-text>
														<v-row dense>
															<v-col>
																<span 	class="title"
																		v-html="$_rctInpLyt_langFinishedText" />
															</v-col>
														</v-row>
													</v-card-text>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row	align="center"
									justify="center">
								<!-- ok button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_rctInpLyt_styleStepperActionButtonBlock"
											:color="$_rctInpLyt_styleStepperActionButtonColorFinish"
											:dark="$_rctInpLyt_styleStepperActionButtonDark"
											:depressed="$_rctInpLyt_styleStepperActionButtonDepressed"
											:elevation="$_rctInpLyt_styleStepperActionButtonElevation"
											:large="$_rctInpLyt_styleStepperActionButtonLarge"
											:light="$_rctInpLyt_styleStepperActionButtonLight"
											:outlined="$_rctInpLyt_styleStepperActionButtonOutlined"
											:rounded="$_rctInpLyt_styleStepperActionButtonRounded"
											:small="$_rctInpLyt_styleStepperActionButtonSmall"
											:text="$_rctInpLyt_styleStepperActionButtonFlat"
											@click="openLink($_rctInpLyt_linkOkButton)"
											v-text="$_rctInpLyt_langOkButton" />
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'RecruitInputLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				valid_: true,

				errorMessage_: null,
				onProgress_: false,

				stepNumber_: 1,

				mode_: {
					input: true,
					submit: false,
					finish: false
				},

				completed_: {
					input: false,
					submit: false,
					finish: false
				},

				step_: {
					input: {
						step: 1,
						title: 'Input'
					},
					submit: {
						step: 2,
						title: 'Submit'
					},
					finish: {
						step: 3,
						title: 'Finished'
					}
				}
			}
		},
		computed: {
			// params
			$_rctInpLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_rctInpLyt_paramsAppliedRecruitmentId() {
				const self_ = this;
				const params_ = self_.$_rctInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.appliedRecruitmentId
			},
			$_rctInpLyt_paramsAppliedScheduleId() {
				const self_ = this;
				const params_ = self_.$_rctInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.appliedScheduleId
			},
			$_rctInpLyt_paramsRecruitmentId() {
				const self_ = this;
				const params_ = self_.$_rctInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.recruitmentId
			},
			$_rctInpLyt_paramsScheduleId() {
				const self_ = this;
				const params_ = self_.$_rctInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.scheduleId
			},
			$_rctInpLyt_paramsStepId() {
				const self_ = this;
				const params_ = self_.$_rctInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.stepId
			},
			// current user
			$_rctInpLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_rctInpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_rctInpLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_rctInpLyt_stateInput() {
				const self_ = this;
				return self_.getInputState()
			},
			$_rctInpLyt_stateInputData() {
				const self_ = this;
				const input_ = self_.$_rctInpLyt_stateInput
				if(self_.isFalse(input_)) { return null }
				return input_.data
			},
			// info
			$_rctInpLyt_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'contact')
			},
			$_rctInpLyt_infoContactUid() {
				const self_ = this;
				const contact_ = self_.$_rctInpLyt_infoContact;
				if(self_.isEmpty(contact_)) { return null }
				return contact_.uid
			},
			$_rctInpLyt_infoMessage() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'message')
			},
			$_rctInpLyt_infoMessageTitle() {
				const self_ = this;
				const message_ = self_.$_rctInpLyt_infoMessage;
				if(self_.isEmpty(message_)) { return null }
				return message_.title
			},
			$_rctInpLyt_infoMessageText() {
				const self_ = this;
				const message_ = self_.$_rctInpLyt_infoMessage;
				if(self_.isEmpty(message_)) { return null }
				return message_.text
			},
			// lang
			$_rctInpLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_rctInpLyt_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'submitButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_rctInpLyt_langConfirmButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'confirmButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_rctInpLyt_langFinishedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_rctInpLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_rctInpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_rctInpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_rctInpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// link
			$_rctInpLyt_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'okButton')
			},
			// style
			$_rctInpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_rctInpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_rctInpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_rctInpLyt_styleStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepper')
			},
			$_rctInpLyt_styleStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_rctInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_rctInpLyt_styleStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_rctInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_rctInpLyt_styleStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_rctInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_rctInpLyt_styleStepperSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperSheet')
			},
			$_rctInpLyt_styleStepperSheetColor() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_rctInpLyt_styleStepperSheetDark() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_rctInpLyt_styleStepperSheetElevation() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_rctInpLyt_styleStepperSheetLight() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_rctInpLyt_styleStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperHeaderCard')
			},
			$_rctInpLyt_styleStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_rctInpLyt_styleStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_rctInpLyt_styleStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_rctInpLyt_styleStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_rctInpLyt_styleStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_rctInpLyt_styleStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_rctInpLyt_styleStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_rctInpLyt_styleStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_rctInpLyt_styleStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_rctInpLyt_styleStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperBodyCard')
			},
			$_rctInpLyt_styleStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_rctInpLyt_styleStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_rctInpLyt_styleStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_rctInpLyt_styleStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_rctInpLyt_styleStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_rctInpLyt_styleStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_rctInpLyt_styleStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_rctInpLyt_styleStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_rctInpLyt_styleStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_rctInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_rctInpLyt_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperActionButton')
			},
			$_rctInpLyt_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_rctInpLyt_styleStepperActionButtonColorSubmit() {
				const self_ = this;
				const actionButton_ =self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.submit) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_rctInpLyt_styleStepperActionButtonColorBack() {
				const self_ = this;
				const actionButton_ =self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.back) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_rctInpLyt_styleStepperActionButtonColorConfirm() {
				const self_ = this;
				const actionButton_ =self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.confirm) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_rctInpLyt_styleStepperActionButtonColorFinish() {
				const self_ = this;
				const actionButton_ =self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.finish) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_rctInpLyt_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_rctInpLyt_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_rctInpLyt_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_rctInpLyt_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_rctInpLyt_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_rctInpLyt_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_rctInpLyt_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_rctInpLyt_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_rctInpLyt_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_rctInpLyt_styleQuestionActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'questionActionButton')
			},
			$_rctInpLyt_styleQuestionActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_rctInpLyt_styleQuestionActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_rctInpLyt_styleQuestionActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_rctInpLyt_styleQuestionActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_rctInpLyt_styleQuestionActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_rctInpLyt_styleQuestionActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_rctInpLyt_styleQuestionActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_rctInpLyt_styleQuestionActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_rctInpLyt_styleQuestionActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_rctInpLyt_styleQuestionActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_rctInpLyt_styleQuestionActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_rctInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_rctInpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_rctInpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_rctInpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		watch: {
			currentTime_: '$_rctInpLyt_checkTime'
		},
		created() {
			const self_ = this;

			// set initial input status
			self_.$_rctInpLyt_setInputState()
		},
		methods: {
			$_rctInpLyt_setInputState() {
				const self_ = this;
				// reset
				self_.resetInput()
				// set
				self_.$_rctInpLyt_setInputUser()
				self_.$_rctInpLyt_setInputContact()
				self_.$_rctInpLyt_setInputPageInfo()
				self_.$_rctInpLyt_setInputData()
				// recruit
				self_.$_rctInpLyt_setInputRecruit()
			},
			$_rctInpLyt_setInputUser(){
				const self_ = this;

				const uid_ = self_.$_rctInpLyt_currentUserUid;
				
				let user_ = {}
				user_[uid_] = true;

				self_.setInputState('user', user_)
			},
			$_rctInpLyt_setInputContact(){
				const self_ = this;

				const uid_ = self_.$_rctInpLyt_infoContactUid;
				
				let contact_ = {}
				contact_[uid_] = true;

				self_.setInputState('contact', contact_)
			},
			$_rctInpLyt_setInputPageInfo(){
				const self_ = this;

				const name_ = self_.getPageState('name')
				const type_ = self_.getPageState('type')
				
				let page_ = {}
				page_[name_] = true;
				page_[type_] = true;

				self_.setInputState('pageInfo', page_)
			},
			$_rctInpLyt_setInputData() {
				const self_ = this;

				let data_ = {}
				let options_ = {}

				Object.keys(self_.contents).forEach(key => {
					data_[key] = {}

					// order
					data_[key].order = self_.contents[key].order;

					// question title & text
					data_[key].question = {}
					data_[key].question.title = self_.$_rctInpLyt_langContentTitle(self_.contents[key])
					data_[key].question.text = self_.$_rctInpLyt_langContentText(self_.contents[key])

					// type
					Object.keys(self_.contents[key].type).forEach(typeKey => {
						if(self_.contents[key].type[typeKey]) { data_[key].type = typeKey }
					})

					// default answer (empty or zero)
					if(		self_.contents[key].type.combobox || // (free text)
							self_.contents[key].type.textarea || 
							self_.contents[key].type.textField ) { 
						data_[key].answer = '';
					} else if(	self_.contents[key].type.slider ) { 
						data_[key].answer = 0
					} else if(	self_.contents[key].type.comboboxMultiple || 
								self_.contents[key].type.selectMultiple ) { 
						data_[key].answer = [] 
					} else if(	self_.contents[key].type.checkbox || 
								self_.contents[key].type.switch ) { 
						data_[key].answer = {}

						options_ = self_.contents[key].options

						Object.keys(options_).forEach(optionKey => {
							data_[key].answer[optionKey] = {
								value: false,
								order: options_[optionKey].order,
								text: options_[optionKey].text,
								isCorrectAnswer: options_[optionKey].isCorrectAnswer
							}
						})
					} else { // radio, combobox (select option), select
						data_[key].answer = {}
					}	

					// score
					data_[key].score = self_.contents[key].score;
				})

				self_.setInputState('data', data_)

				return
			},
			// recruit
			$_rctInpLyt_setInputRecruit() {
				const self_ = this;

				const appliedRecruitment_ = self_.$_rctInpLyt_paramsAppliedRecruitmentId;
				const appliedSchedule_ = self_.$_rctInpLyt_paramsAppliedScheduleId;

				const recruitment_ = self_.$_rctInpLyt_paramsRecruitmentId;
				const schedule_ = self_.$_rctInpLyt_paramsScheduleId;
				const step_ = self_.$_rctInpLyt_paramsStepId;

				let recruit_ = {}
				if(!self_.isFalse(appliedRecruitment_) && !self_.isFalse(appliedSchedule_)) {
					recruit_.appliedRecruitmentId = appliedRecruitment_;
					recruit_.appliedScheduleId = appliedSchedule_;
				}
				if(!self_.isFalse(recruitment_) && !self_.isFalse(schedule_) && !self_.isFalse(step_)) {
					recruit_.recruitmentId = recruitment_;
					recruit_.scheduleId = schedule_;
					recruit_.stepId = step_;
				}
				
				self_.setInputState('recruitInfo', recruit_)
			},
			// button action
			$_rctInpLyt_submit() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.mode_ = { 
						input: false,
						submit: true,
						finish: false
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						input: true,
						submit: false,
						finish: false
					}

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_rctInpLyt_top')
				}).catch(error => {
					self_.errorMessage_ = error;
					vuetify_.goTo('#_rctInpLyt_top')
				})
			},
			$_rctInpLyt_back() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.mode_ = { 
						input: true
					}

					self_.stepNumber_--;
					
					self_.completed_ = { 
						input: false,
						submit: false,
						finish: false
					}

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_rctInpLyt_top')
				})
			},
			$_rctInpLyt_confirm() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				// prevent double-click of confirm button
				if(self_.onProgress_) { return }
				else {
					self_.onProgress_ = true;
				}

				let id_ = null;

				// add input & message
				Promise.resolve().then(() => {
					// recruit application
					return self_.$_rctInpLyt_setUserStateRecruit()
				}).then(() => {
					return self_.$_rctInpLyt_addInput()
				}).then(() => {
					return self_.$_rctInpLyt_addMessage()
				}).then(() => {
					self_.mode_ = { 
						input: false,
						submit: false,
						finish: true
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						input: true,
						submit: true,
						finish: false
					}

					self_.onProgress_ = false;

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_rctInpLyt_top')
				}).catch(error => {
/* error */			self_.logError('Error', '$_rctInpLyt_confirm()', error)
				})
			},
			// recruit application
			$_rctInpLyt_setUserStateRecruit() {
				const self_ = this;

				const appliedRecruitment_ = self_.$_rctInpLyt_paramsAppliedRecruitmentId;
				const appliedSchedule_ = self_.$_rctInpLyt_paramsAppliedScheduleId;

				if(self_.isFalse(appliedRecruitment_) || self_.isFalse(appliedSchedule_)) {
					return
				}

				const recruit_ = self_.getUserState('recruit')
				const recruitment_ = recruit_[appliedRecruitment_]

				recruitment_.appliedSchedule[appliedSchedule_] = true;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.setUserRecruit(appliedRecruitment_, recruitment_)
					}).then(() => {
						return self_.initializeUser('recruit')
					}).then(() => {
						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: created() -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			// input
			$_rctInpLyt_addInput() {
				const self_ = this;
				
				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.addInput()
					}).then(result => {
						return self_.addInputData(result.id)
					}).then(() => {
						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: created() -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			// massage
			$_rctInpLyt_addMessage() {
				const self_ = this;
				
				const uid_ = self_.$_rctInpLyt_currentUserUid;

				const title_ = self_.$_rctInpLyt_infoMessageTitle;
				const text_ = self_.$_rctInpLyt_infoMessageText;
				const contact_ = self_.$_inRctAplpLyt_infoContactUid;

				// title
				self_.setMessageState('title', title_)

				// text
				self_.setMessageState('text', text_)

				// sender
				self_.setMessageState('sender', contact_)

				// to
				self_.setMessageState('to', uid_)

				// user
				let user_ = {}
				user_[uid_] = true;
				user_[contact_] = true;
				
				return self_.addMessage()
			}
		}
	}
</script>

<style scoped>
	.stepper_ {
		box-shadow: none;
		background-color: transparent;
	}
	.stepperHeader_ {
		background-color: transparent;
		box-shadow: none;
		height: 80px;
	}
	.stepperItem_ {
		background-color: transparent;
		box-shadow: none;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>
